<template>
  <div class="student">
    <div class="head">
      <div class="article">
        <div class="avatar">
          <img :src="info.userPicUrl" alt="" style="object-fit: cover" />
        </div>
        <div class="info">
          <p class="name">
            {{ info.studentName
            }}<span :class="info.sex === 1 ? 'man' : 'women'"></span>
          </p>
          <!-- <div class="half">
            <p><span class="lab">{{$t('form.gender')}}：</span>{{info.sex === 1? '男': '女'}}</p>
          </div> -->
          <div class="half">
            <p>
              <span class="lab">{{ $t('form.birth') }}{{ $t('colon') }}</span
              >{{ info.birthday }}
            </p>
            <p>
              <span class="lab"
                >{{ $t('StudentDetail.course') }}{{ $t('colon') }}</span
              >{{ info.courseName }}
            </p>
          </div>
          <p>
            <span class="lab"
              >{{ $t('StudentDetail.school') }}{{ $t('colon') }}</span
            >{{ info.school }}
          </p>
          <p>
            <span class="lab"
              >{{ $t('StudentDetail.year') }}{{ $t('colon') }}</span
            >{{ info.schoolYear }}
          </p>
          <p>
            <span class="lab"
              >{{ $t('StudentDetail.targetUniversities')
              }}{{ $t('colon') }}</span
            >{{ info.targetUniversitys }}
          </p>
          <p>
            <span class="lab"
              >{{ $t('StudentDetail.degreeCourse') }}{{ $t('colon') }}</span
            >{{ info.targetColleges }}
          </p>
          <p>
            <span class="lab"
              >{{ $t('StudentDetail.subjects') }}{{ $t('colon') }}</span
            >{{
              info.studiedSubjects.length > 0
                ? info.studiedSubjects
                    .map((item) => item.subjectName)
                    .join(', ')
                : ''
            }}
          </p>
          <p class="situation">
            <span
              >{{ $t('StudentDetail.completed') }}{{ $t('colon')
              }}{{ courseData.completedCount }} {{ $t('common.lessons') }}</span
            >
            <span
              >{{ $t('StudentDetail.Booked') }}{{ $t('colon')
              }}{{ courseData.waitingStartCount }}
              {{ $t('common.lessons') }}</span
            >
          </p>
        </div>
        <div class="btns">
          <router-link :to="{path: '/user/invite', query: {id: info.studentId, name: info.studentName,course:info.courseName}}" class="ui-btn">{{$t('StudentDetail.invitation')}}</router-link>
        </div>
      </div>
    </div>
    <div class="article">
      <ul class="tabs">
        <li :class="tab === 0 ? 'on' : ''" @click="tab = 0">
          {{ $t('StudentDetail.ScheduledCourses') }}
        </li>
        <li :class="tab === 1 ? 'on' : ''" @click="tab = 1">
          {{ $t('StudentDetail.CompletedCourse') }}
        </li>
        <li :class="tab === 2 ? 'on' : ''" @click="tab = 2">
          {{ $t('StudentDetail.InvitationRecord') }}
        </li>
      </ul>
      <ul class="list" v-show="tab === 0">
        <li v-for="(item, index) in courseList" :key="index">
          <!-- {{item}} -->
          <div class="info">
            <div class="cell">
              <p>{{ item.courseName }}</p>
              <p>
                {{ $t('StudentDetail.courseDuration') }}{{ $t('colon') }}
                {{ item.courseDuration / 60 }}
                {{ $t('StudentDetail.hour') }}
              </p>
              <p>
                {{ $t('StudentDetail.status') }}{{ $t('colon')
                }}{{ item.stateName }}
              </p>
            </div>
            <div class="cell"></div>
            <div class="cell">
              <p>
                {{ $t('common.startTime') }}{{ $t('colon')
                }}{{ getTime(item.beginTime) }}
              </p>
              <p>
                {{ $t('common.endTime') }}{{ $t('colon')
                }}{{ getTime(item.endTime) }}
              </p>
            </div>
          </div>
          <div class="btns" v-if="item.teacherId === user.uid">
            <a class="ui-btn" @click="showConfirmInfo(item.id)">{{
              $t('cancel')
            }}</a>
          </div>
        </li>
        <div class="ui-empty" v-if="courseList.length === 0">
          <!-- No data -->
        </div>
      </ul>
      <ul class="list" v-show="tab === 1">
        <template v-if="courseList2.length">
          <li v-for="(item, index) in courseList2" :key="index">
            <div class="info">
              <div class="cell">
                <p>{{ item.courseName }}</p>
                <p>
                  {{ $t('StudentDetail.courseDuration') }}{{ $t('colon')
                  }}{{ item.courseDuration / 60 }}
                  {{ $t('StudentDetail.hour') }}
                </p>
                <p>
                  {{ $t('StudentDetail.status') }}{{ $t('colon')
                  }}{{ item.stateName }}
                </p>
              </div>
              <div class="cell"></div>
              <div class="cell">
                <p>
                  {{ $t('common.startTime') }}{{ $t('colon')
                  }}{{ getTime(item.beginTime) }}
                </p>
                <p>
                  {{ $t('common.startTime') }}{{ $t('colon')
                  }}{{ getTime(item.endTime) }}
                </p>
              </div>
            </div>
          </li>
        </template>
        <!-- 暂无数据 -->
        <div class="ui-empty" v-else></div>
      </ul>
      <ul class="list" v-show="tab === 2">
        <li v-for="(item, index) in courseList3" :key="index">
          <div class="info">
            <div class="cell">
              <p>{{ item.courseName }}</p>
              <p>
                {{ $t('StudentDetail.courseDuration') }}{{ $t('colon')
                }}{{ item.courseDuration / 60 }} {{ $t('StudentDetail.hour') }}
              </p>
              <!-- <p>Course status： Not started</p> -->
            </div>
            <div class="cell">
              <p>
                {{ $t('StudentDetail.InvitationTime') }}{{ $t('colon')
                }}{{ getTime(item.createTime) }}
              </p>
              <p>
                {{ $t('StudentDetail.status') }}{{ $t('colon')
                }}{{ item.stateName }}
              </p>
            </div>
            <div class="cell">
              <p>
                {{ $t('common.startTime') }}{{ $t('colon')
                }}{{ getTime(item.beginTime) }}
              </p>
              <p>
                {{ $t('common.endTime') }}{{ $t('colon')
                }}{{ getTime(item.endTime) }}
              </p>
            </div>
          </div>
          <div class="btns" v-if="item.teacherId === user.uid">
            <a class="ui-btn" @click="showConfirmInfo(item.id)">{{
              $t('cancel')
            }}</a>
          </div>
        </li>
        <div class="ui-empty" v-if="courseList3.length === 0">
          <!-- No data -->
        </div>
      </ul>
    </div>
    <comfirm @cancel="cancel" @submit="comfirm" :info="comfirmInfo" />
  </div>
</template>
<i18n>
{
  "cn": {
    "StudentDetail":{
      "cancelSuccess":"取消成功",
      "course":"课程",
      "school":"学校",
      "targetUniversities":"目标大学",
      "degreeCourse":"专业课程",
      "year":"年级",
      "subjects":"学习科目",
      "completed":"已完成",
      "Booked":"已预约",
      "invitation":"课程邀约",
      "scheduledCourse":"预约课程",
      "completedCourse":"已完成课程",
      "InvitationRecord":"邀约记录",
      "InvitationTime":"邀约时间",
      "courseDuration":"课程时长",
      "status":"状态",
      "ScheduledCourses":"已预约课堂",
      "CompletedCourse":"已完成课堂",
      "InvitationRecord":"邀约记录",
      "hour":"小时",
      "comfirmInfo":{
        "title":"提示",
        "topic":"取消预约",
        "desc":"原时段将释放，学费将退还至学生账户",
        "cancel":"取消",
        "comfirm":"提交"
      }
    }
  },
  
  "TW": {
    "StudentDetail":{
      "cancelSuccess":"取消成功",
      "course":"課程",
      "school":"學校",
      "targetUniversities":"目標大學",
      "degreeCourse":"專業課程",
      "year":"年級",
      "subjects":"學習科目",
      "completed":"已完成",
      "Booked":"已預約",
      "invitation":"課程邀約",
      "scheduledCourse":"預約課程",
      "completedCourse":"已完成課程",
      "InvitationRecord":"邀約記錄",
      "InvitationTime":"邀約時間",
      "courseDuration":"課程時長",
      "status":"狀態",
      "ScheduledCourses":"已預約課堂",
      "CompletedCourse":"已完成課堂",
      "InvitationRecord":"邀約記錄",
      "hour":"小时",
      "comfirmInfo":{
        "title":"提示",
        "topic":"取消預約",
        "desc":"原時段將釋放，學費將退還至學生帳戶",
        "cancel":"取消",
        "comfirm":"提交"
      }
    }
  },
  "en": {
    "StudentDetail":{
      "cancelSuccess":"Cancel success",
      "course":"Course",
      "school":"School",
      "targetUniversities":"Target Universities",
      "degreeCourse":"Degree Course",
      "year":"Year",
      "subjects":"Subjects",
      "completed":"Completed",
      "Booked":"Booked",
      "invitation":"Invitation courses",
      "scheduledCourse":"Scheduled courses",
      "completedCourse":"Completed course",
      "InvitationRecord":"Invitation record",
      "InvitationTime":"Invitation time",
      "status":"Status",
      "courseDuration":"Course duration",
      "ScheduledCourses":"Scheduled lessons",
      "CompletedCourse":"Completed lessons",
      "InvitationRecord":"Invitation record",
      "hour":"hours",
      "comfirmInfo":{
        "title":"Tips",
        "topic":"Cancel invitation",
        "desc":"The original period will be released and the tuition fee will be returned to the student account",
        "cancel":"Cancel",
        "comfirm":"Submit"
      }
    }
  }
}
</i18n>
<script>
import {
  getBaseInfo,
  getStudentInvitedCourseList,
  getStudentStudyCourseList,
  
} from '@/service/studentApi.js'
import { delOrderCourse } from '@/service/api.js'
import { getOrderCourseStats } from '@/service/teacherApi.js'
import comfirm from '@/components/Comfirm.vue'
import moment from 'moment'
export default {
  components: { comfirm },
  data() {
    return {
      tab: 0,
      info: {
        studiedSubjects: [],
      },
      comfirmInfo: {
        id: '',
        show: false,
        title: this.$t('StudentDetail.comfirmInfo.title'),
        topic: this.$t('StudentDetail.comfirmInfo.topic'),
        desc: this.$t('StudentDetail.comfirmInfo.desc'),
        cancel: this.$t('StudentDetail.comfirmInfo.cancel'),
        comfirm: this.$t('StudentDetail.comfirmInfo.comfirm'),
      },
      courseList: [],
      courseList2: [],
      courseList3: [],
      courseData: '',
    }
  },
  methods: {
    showConfirmInfo(id) {
      this.comfirmInfo.show = true
      this.comfirmInfo.id = id
    },
    async getBaseInfo() {
      const res = await getBaseInfo({ studentId: this.$route.query.id })
      if (res.data.status === 1) {
        this.info = res.data
        this.info.birthday =
          this.info.birthday !== 0
            ? moment(this.info.birthday, 'YYYYMMDD').format('DD/MM/YYYY')
            : ''
        this.info.targetColleges = !!this.info.targetColleges
          ? this.info.targetColleges.split('$_$').join(', ')
          : ''
        this.info.targetUniversitys = !!this.info.targetUniversitys
          ? this.info.targetUniversitys.split('$_$').join(', ')
          : ''
      }
    },
    // 学生学习的课程（已完成）
    // Scheduled courses
    // Completed course
    async getStudentStudyCourseList(type) {
      const res = await getStudentStudyCourseList({
        state: type,
        studentId: this.$route.query.id,
      })
      if (res.data.status === 1) {
        if (type === 1) {
          this.courseList = res.data.data
        } else {
          this.courseList2 = res.data.data
        }
      }
    },
    async getOrderCourseStats() {
      const res = await getOrderCourseStats({ studentId: this.$route.query.id })
      if (res.data.status === 1) {
        this.courseData = res.data.data
      }
    },
    // Invitation record
    async getStudentInvitedCourseList() {
      // 某个学生被邀约的课程 （已完成）
      const res = await getStudentInvitedCourseList({
        studentId: this.$route.query.id,
      })
      if (res.data.status === 1) {
        this.courseList3 = res.data.data
      }
    },
    cancel(show) {
      this.comfirmInfo.show = false
      this.comfirmInfo.id = ''
    },
    async comfirm() {
      const res = await delOrderCourse({
        orderCourseId: this.comfirmInfo.id,
      })

      if (res.data.status === 1) {
        this.$message({
          type: 'success',
          message: this.$t('StudentDetail.cancelSuccess'),
        })
        this.comfirmInfo.show = false
        this.init()
      }
    },
    getTime(time) {
      return moment(time * 1000).format('DD/MM/YYYY HH:mm')
    },
    init() {
      this.getBaseInfo()
      this.getOrderCourseStats()
      this.getStudentStudyCourseList(1)
      this.getStudentStudyCourseList(2)
      this.getStudentInvitedCourseList()
    },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.invitation-btn {
  margin-left: 20px;
  padding: 10px;
  color: #fff;
  font-size: 16px;
  border-radius: 10px;
  background: #d96d66;
}
.man {
  margin-left: 10px;
  width: 40px;
  height: 40px;
  background-image: url(../assets/man.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
}
.women {
  margin-left: 10px;
  width: 40px;
  height: 40px;
  background-image: url(../assets/women.png);
  background-repeat: no-repeat;
  background-position: 0px 5px;
  background-size: cover;
  display: inline-block;
}
.head {
  padding: 40px 0 50px;
  background: #fff;
  box-shadow: 0 6px 14px rgba($color: #000, $alpha: 0.05);
  .article {
    padding: 30px;
    display: flex;
  }
  .avatar {
    width: 320px;
    height: 320px;
    position: relative;
    font-size: 0;
    margin-right: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .btns {
    border-radius: 5px;
    width: 236px;
    padding: 80px 0 0 30px;
    text-align: left;
    margin-top: 33px;
    height: 267px;
    border-left: 1px solid #dcdcdc;
    text-align: center;
    .ui-btn {
      margin-top: 30px;
    }
  }
  .info {
    padding: 12px 50px 0 0;
    flex: 1;
    p {
      margin-bottom: 10px;
      font-size: 18px;
  color: #555;
      line-height: 26px;
    }
    .name {
      font-size: 48px;
      color: #002147;
      line-height: 64px;
      margin-bottom: 25px;
    }
    .lab {
      color: #000;
    }
    .situation {
      margin: 25px 0 0;
      color: #000;
      font-weight: bold;
      span:first-child {
        margin-right: 40px;
      }
    }
  }
  .half {
    display: flex;
  }
  .half p {
    flex: 1;
  }
}
.tabs {
  overflow: hidden;
  margin-top: 40px;
  padding-left: 30px;
  li {
    float: left;
    height: 42px;
    width: 180px;
    border-radius: 12px 12px 0 0;
    line-height: 42px;
    text-align: center;
    background: #a9c4b1;
    color: #fff;
    margin-right: 10px;
    cursor: pointer;
    &:hover {
      background: darken(#a9c4b1, 10%);
    }
    &.on {
      background: #002147;
    }
  }
}
.list {
  // background: #fff; padding: 0 50px; margin-bottom: 90px; box-shadow: 0 6px 12px rgba($color: #000000, $alpha: .05);
  li {
    // margin: 10px 0;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e0e0e0;
    margin: 20px;
    padding: 30px 0 50px;
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    align-items: center;
    box-shadow: 3px 6px 3px #dcdcdc;
    // &+li{border: 1px dashed #707070;}
  }
  .btns {
    margin-left: 30px;
  }
  p {
    margin-top: 20px;
    line-height: 24px;
    font-size: 18px;
  }
  .info {
    flex: 1;
    display: flex;
  }
  .cell {
    width: 33.33%;
    padding-right: 10px;
  }
}
</style>